import { Option } from "@/components/types/option";

import { OptionFieldsConfig } from "..";

function getValueKey<TValue extends Option>(
  obj: TValue | string | number,
  { dataKey }: OptionFieldsConfig<TValue>,
): string | number | undefined {
  if (typeof obj === "string" || typeof obj === "number") {
    return obj;
  }

  if (typeof dataKey === "function") {
    return dataKey(obj);
  }

  return obj[dataKey];
}

export { getValueKey };
